import * as React from 'react';
import { BookingDetailSection, SectionProps } from '../../SharedSections/BookingDetailSection';
import { GetFormattedDate, GetFormattedDateTime, GetFormattedTime } from '../../../../Events/EventCards/EventUtils';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

export function EventDateTimeInfoSection({ booking, canEdit, onEdit, isInvoiced }: SectionProps) {
	const intl = useIntl();

	if (!booking.bookedSummary) {
		console.error('Booked summary missing, this should not happen');
		return <></>;
	}

	const ferryTrip = booking?.bookedSummary?.ferryTrip;

	// Use eventSeriesId for the link, with eventId from booking summary as fallback
	const eventSeriesId = ferryTrip?.eventDetail?.eventSeriesId ?? booking.bookedSummary.eventId;

	const sectionContent = (
		<>
			<Link className="event-booking__header hide-underline" to={`/event-details/${eventSeriesId}`}>
				<p className="event-name">{ferryTrip?.getEventName()}</p>
			</Link>
			<p className="event-date">{GetFormattedDate(ferryTrip?.startDate, ferryTrip?.endDate)}</p>
			<p className="event-time">{GetFormattedTime(ferryTrip?.startTime, ferryTrip?.endTime)}</p>
		</>
	);

	return (
		<BookingDetailSection
			sectionName={intl.formatMessage({
				id: 'event-booking-details__event-date-time-section__label',
				defaultMessage: 'Date/time',
			})}
			sectionContent={sectionContent}
			sectionClassName="event-date-time"
			icon={{
				name: 'calendar_today',
				useMaterialIcons: true,
			}}
			modificationRules={{
				canEdit: canEdit,
				editType: 'event-date-time',
				onEdit: onEdit,
				isInvoiced: isInvoiced,
			}}
		/>
	);
}
